import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as appConstants from '../../../overrides/appconstants'
import * as appUtility from '../../../infrastructure/apputilityfunctions'
import * as actions from '../actions/micustomeractions'
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import {
    Stepper,
    Step,
    StepLabel,
    Button,
    Box,
    Typography,
    TextField,
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckIcon from '@mui/icons-material/Check';
import * as constant from '../constants'
import { Search } from '@mui/icons-material';
import SearchQuote from './SearchQuote';
import * as appUtilityFunctions from '../../../infrastructure/apputilityfunctions'
export default function BasicInfo() {

    const dispatch = useDispatch();
    const state = useSelector(state => state.miCustomerSharedReducer);

    const { register, handleSubmit, setValue, formState: { errors } } = useForm();
    var masters = state.masters;
    let newEnq = state.basicInfoNewEnq;
    let modalState = state.modalState;
    let productSelection = state.productSelection;
    
    const location = useLocation();
    let payment = state.payment;
    const today = new Date()
    useEffect( () => {
        const params = new URLSearchParams(location.search);
        const id = params.get('refferlId'); // note: it's 'refferlId' as per your URL
        let name="refferalLinkValue";
        let value=id;
         dispatch(actions.handleBasicInfoQuoteChange({ name, value }));
      }, [location.search]);
      useEffect( () => {
        const params = new URLSearchParams(location.search);
        const id = params.get('mode'); // note: it's 'refferlId' as per your URL
       if(id=="payment")
       {
        dispatch(actions.handleNextStep(4));
       }
      }, [location.search]);


    useEffect(() => {
        let valuesToMap = [
            { "visaEmirate": newEnq.visaEmirate },
            { "visaType": newEnq.visaType },
            { "salaryBand": newEnq.salaryBand },
            { "sponsorName": newEnq.sponsorName },
            { "mobile": newEnq.mobile },
            { "email": newEnq.email },
            { "isSponsorMember": newEnq.isSponsorMember },
            { "enquiryNo": newEnq.enquiryNo },
            { "enquiryId": newEnq.enquiryId },
            { "insuredType": newEnq.insuredType },
            { "crNo": newEnq.crNo },
            { "tradeLicNo": newEnq.tradeLicNo },
            { "tradeLicExp": newEnq.tradeLicExp },
            { "isSponsorMemberN": newEnq.isSponsorMemberN },
        ];
        valuesToMap.forEach(i => Object.keys(i).forEach(key => setValue(key, i[key])));
    }, [newEnq]);



    const handleBasicInfoQuoteCheckBoxChange = (e) => {
        let checked = e.target.checked;
        dispatch(actions.handleBasicInfoQuoteChange({ name: 'isSponsorMember', value: checked }));
        if (checked) {
            dispatch(actions.handleBasicInfoQuoteChange({ name: 'isSponsorMemberN', value: false }));
        }

    }
    const handleBasicInfoQuoteCheckBoxChangeNo = (e) => {
        let checked = e.target.checked;
        if (checked) {
            dispatch(actions.handleBasicInfoQuoteChange({ name: 'isSponsorMember', value: false }));
        }

        dispatch(actions.handleBasicInfoQuoteChange({ name: 'isSponsorMemberN', value: checked }));
    }
    const handleBasicInfoQuoteChange = (e) => {
        let { name, value } = e.target;
        // if (name == "tradeLicExp") {
        //     alert(value);
        //     alert(appUtility.formatDate(today));
        // }
        if (value == "") { value = null; }
        dispatch(actions.handleBasicInfoQuoteChange({ name, value }));

        if (name == "visaEmirate") {
            dispatch(actions.updateProductSelectionParams({ name, value }));
        }
        if (name == "visaType" && value == appConstants.VISA_TYPE_SELF_DEP) {
            // dispatch(actions.updateProductSelectionParams({ name, value }));
            dispatch(actions.handleBasicInfoQuoteChange({ name: 'isSponsorMember', value: false }));
        }
    }

    useEffect(() => {
        if ((productSelection?.visaEmirate == null) || (productSelection?.visaEmirate == "")) {
            dispatch(actions.updateProductSelectionParams({ name: "visaEmirate", value: newEnq?.visaEmirate }));
        }
        // if ((productSelection?.planType == null) || (productSelection?.planType == "")) {
        //     dispatch(actions.updateProductSelectionParams({ name: "planType", value: newEnq?.planType }));
        // }
    }, [newEnq?.visaEmirate]);



    let VisaEmirate = <select className={errors.visaEmirate ? "form-select is-invalid" : "form-select"} data-toggle="select2" id="visaEmirate" name="visaEmirate"
        value={newEnq.visaEmirate}
        disabled={newEnq?.isRefertoUW || newEnq?.isPolicyIssued}
        {...register("visaEmirate", { required: "Field Is Required"/* "Select an Emirate..." */, onChange: (e) => handleBasicInfoQuoteChange(e) })}>
        <option value="">--Visa Emirate--</option>
        {masters?.visaEmirateMasters?.filter(emirate => !appConstants.VISA_EMIRATE_COUNTRY.includes(emirate.id))?.map((visaEmirate) => (
            <option value={visaEmirate.id} key={visaEmirate.id}>
                {visaEmirate.name}
            </option>
        ))}
    </select>
    let SalaryBand =
        <select className={errors.salaryBand ? "form-select is-invalid" : "form-select"}
            data-toggle="select2" id="salaryBand" name="salaryBand"
            disabled={newEnq?.isRefertoUW || newEnq?.isPolicyIssued}
            value={newEnq.salaryBand}
            {...register("salaryBand", { required: (newEnq?.visaEmirate == appConstants.VISA_EMIRATE_DUBAI) && "Field is required", onChange: (e) => handleBasicInfoQuoteChange(e) })}>
            <option value=''>--Salary Band--</option>
            {masters?.salaryBandMasters?.map((salary, index) => (
                <option value={salary.domainValue} key={index}>
                    {salary.domainValueName}
                </option>
            ))}
        </select>
    let InsuredType = <select className={errors.insuredType ? "form-select is-invalid" : "form-select"} data-toggle="select2" id="insuredType" name="insuredType"
        value={newEnq.insuredType}
        disabled={newEnq?.isRefertoUW || newEnq?.isPolicyIssued}
        {...register("insuredType", { required: "Field Is Required"/* "Select an Emirate..." */, onChange: (e) => handleBasicInfoQuoteChange(e) })}>
        <option value="">--Insured Type--</option>
        {masters?.insuredTypeMasters?.map((ins) => (
            <option value={ins.domainValue} key={ins.domainValue}>
                {ins.domainValueName}
            </option>
        ))}
    </select>



    let VisaType =
        <select className={errors.visaType ? "form-select is-invalid" : "form-select"} data-toggle="select2" id="visaType" name="visaType"
            disabled={newEnq?.isRefertoUW || newEnq?.isPolicyIssued}
            {...register("visaType", { required: (newEnq?.visaEmirate == appConstants.VISA_EMIRATE_ABU_DHABI || newEnq.visaEmirate == appConstants.VISA_EMIRATE_AL_AIN) && "Field is required", onChange: (e) => handleBasicInfoQuoteChange(e) })}>
            <option value="">--Visa Type--</option>
            {masters?.insuredVisaTypeMasters?.map((visaType) => (
                <option value={visaType.id} key={visaType.id}>
                    {visaType.name}
                </option>
            ))}
        </select>

    let SponserName = <input className={errors.sponsorName ? "form-control is-invalid" : "form-control"}
        placeholder="Sponsor Name"
        id="sponsorName"
        name="sponsorName"
        disabled={newEnq?.isRefertoUW || newEnq?.isPolicyIssued}
        {...register("sponsorName", {
            required: "Field is required",
            pattern: {
                value: /^[A-Za-z ]+$/,
                message: "Sponsor Name must contain only letters and spaces"
            },
            validate: {
                maxLengthCheck: (val) => val.length <= 80 || "Sponsor Name must be 80 characters or less"
            },
            onChange: (e) => handleBasicInfoQuoteChange(e)
        })}
    />
    let CrNo = <input className={errors.crNo ? "form-control is-invalid" : "form-control"}
        placeholder="Cr No"
        id="crNo"
        name="crNo"
        disabled={newEnq?.isRefertoUW || newEnq?.isPolicyIssued}
        {...register("crNo", { required: newEnq?.insuredType == appConstants.INSURED_TYPE_COMP ? "Field is required" : false, onChange: (e) => handleBasicInfoQuoteChange(e) })}
    />
    let TradeLicNo = <input className={errors.tradeLicNo ? "form-control is-invalid" : "form-control"}
        placeholder="Trade License No"
        id="tradeLicNo"
        name="tradeLicNo"
        disabled={newEnq?.isRefertoUW || newEnq?.isPolicyIssued}
        {...register("tradeLicNo", { required: newEnq?.insuredType == appConstants.INSURED_TYPE_COMP ? "Field is required" : false, onChange: (e) => handleBasicInfoQuoteChange(e) })}
    />
    let TradeLicExp = <input className={errors.tradeLicExp ? "form-control is-invalid" : "form-control"}
        placeholder="Trade License Expiry Date"
        id="tradeLicExp"
        name="tradeLicExp"
        type='date'
        disabled={newEnq?.isRefertoUW || newEnq?.isPolicyIssued}
        // min={newEnq?.insuredType == appConstants.INSURED_TYPE_COMP ? appUtility.formatDate(today) : null}
        {...register("tradeLicExp", { required: newEnq?.insuredType == appConstants.INSURED_TYPE_COMP ? "Field is required" : false, onChange: (e) => handleBasicInfoQuoteChange(e), min: newEnq?.insuredType == appConstants.INSURED_TYPE_COMP ? appUtility.formatDate(today) : null })}
    />




    let Mobile = <input className={errors.mobile ? "form-control is-invalid" : "form-control"}
        id="mobile"
        placeholder="05X-XXXXXXX / 0X-XXXXXXX"
        name='mobile'
        disabled={newEnq?.isRefertoUW || newEnq?.isPolicyIssued}
        {...register("mobile", {
            required: "Field is required", pattern: { value: /(^[0][5][0,5,2,6,4,8]{1}[-]?[0-9]{7}$)|(^[0][2,3,4,5,6,7,9]{1}[-]?[0-9]{7}$)/, message: "Format: 05X-XXXXXXX / 0X-XXXXXXX" },
            onChange: (value) => handleBasicInfoQuoteChange(value)
        })}
    />

    let Email = <input className={errors.email ? "form-control is-invalid" : "form-control"}
        type="email" id="email"
        placeholder="Enter Email Address"
        disabled={newEnq?.isRefertoUW || newEnq?.isPolicyIssued}
        name='email'
        {...register("email", {
            required: "Field is required",
            pattern: { value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/, message: "Format: abc@example.com" },
            onChange: (e) => handleBasicInfoQuoteChange(e)
        })}
    />



    const showSearch = () => {
        dispatch(actions.toggleSearch(!modalState.showSearch))

    }
    const onSubmit = async (data) => {
        console.log('Form Data:', state.basicInfoNewEnq);

        var termsRes = false
        if (newEnq?.encryptedEnquiryRefId1 == null && newEnq?.encryptedEnquiryRefId2 == null) {
            termsRes = await dispatch(actions.showTermsAndComdPopapBasicInfo({ name: null, value: null, message: getTermsandConditions() }));
        }
        else {
            termsRes = true
            // await dispatch(actions.updatePaymentTransactionsParams({ name: "termsCond", value: true }))
        }
        if (termsRes == true) {
            var res = null;
            var quoteID = null;
            if (!newEnq?.isRefertoUW && !newEnq?.isPolicyIssued) {
                
                const enquiryData = {
                    ...state.basicInfoNewEnq,
                    quoteUtmSource: state.utmSource
                };
                
                res = await dispatch(actions.saveMICustomerEnquiry(enquiryData))
            }
            else {
                dispatch(actions.handleNextStep(1));
                await dispatch(actions.getfilteredNetworks({ encryptedEnquiryRefId1: newEnq?.encryptedEnquiryRefId1, encryptedEnquiryRefId2: newEnq?.encryptedEnquiryRefId2 }));
            }

        }
        else {
            return false
        }
    };

    const onErrors = (error) => {

        console.log('Form Error:', error);
        // dispatch(actions.handleNextStep(1))
        // dispatch(actions.saveMICustomerEnquiry())
        //   setActiveStep((prevStep) => prevStep + 1);
    };
    return (
        <>
            <ul className="nav nav-tabs nav-bordered mb-1">
            </ul>
            <div className="row g-2">
                <div className="mb-1 col-md-12 d-flex justify-content-end"    >
                    {!modalState?.showSearch && <Button
                        className='mx-2'
                        type='button'
                        style={{ backgroundColor: '#1976d2', color: 'white' }}
                        onClick={showSearch}
                        startIcon={<Search />}
                    >
                        Search Quote
                    </Button>}
                    {modalState?.showSearch && <Button
                        className='mx-2'
                        type='button'
                        style={{ backgroundColor: '#1976d2', color: 'white' }}
                        onClick={showSearch}

                    >
                        New Quote
                    </Button>}
                </div>
            </div>
            {!modalState?.showSearch && <form onSubmit={handleSubmit(onSubmit, onErrors)}>
                <div className="mt-2" >
                    <div className="container">
                        <div className="row pb-3 justify-content-center">
                            <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                                <div className="col-4 text-start">
                                    <label htmlFor="insuredType" className="form-label w-100"><span className='text-danger'>*</span> Insured Type</label>
                                </div>
                                <div className="col-8">
                                    {InsuredType}
                                    {errors.insuredType && <p className="text-danger fst-italic fs-6">{errors.insuredType.message}</p>}
                                </div>
                            </div>
                        </div>
                        <div className="row pb-3 justify-content-center">
                            <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                                <div className="col-4 text-start">
                                    <label htmlFor="visaEmirate" className="form-label w-100"><span className='text-danger'>*</span> Visa Emirate</label>
                                </div>
                                <div className="col-8">
                                    {VisaEmirate}
                                    {errors.visaEmirate && <p className="text-danger fst-italic fs-6">{errors.visaEmirate.message}</p>}
                                </div>
                            </div>
                        </div>
                        {(newEnq?.visaEmirate == appConstants.VISA_EMIRATE_DUBAI) && <div className="row pb-3 justify-content-center">
                            <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                                <div className="col-4 text-start">
                                    <label htmlFor="visaEmirate" className="form-label w-100"><span className='text-danger'>*</span> Salary Band</label>
                                </div>
                                <div className="col-8">
                                    {SalaryBand}
                                    {errors.salaryBand && <p className="text-danger fst-italic fs-6">{errors.salaryBand.message}</p>}
                                </div>
                            </div>
                        </div>}
                        {(newEnq?.visaEmirate == appConstants.VISA_EMIRATE_ABU_DHABI || newEnq.visaEmirate == appConstants.VISA_EMIRATE_AL_AIN) && <div className="row pb-3 justify-content-center">
                            <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                                <div className="col-4 text-start">
                                    <label htmlFor="visaType" className="form-label w-100">{(newEnq?.visaEmirate == appConstants.VISA_EMIRATE_ABU_DHABI || newEnq.visaEmirate == appConstants.VISA_EMIRATE_AL_AIN) && <span className='text-danger'>*</span>} Visa Type</label>
                                </div>
                                <div className="col-8">
                                    {VisaType}
                                    {errors.visaType && <p className="text-danger fst-italic fs-6">{errors.visaType.message}</p>}
                                </div>
                            </div>
                        </div>}
                        <div className="row pb-3 justify-content-center">
                            <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                                <div className="col-4 text-start">

                                    {newEnq?.insuredType == appConstants.INSURED_TYPE_INDIVIDUAL && <label htmlFor="sponsorName" className="form-label w-100"><span className='text-danger'>*</span> Sponsor Name</label>}
                                    {newEnq?.insuredType != appConstants.INSURED_TYPE_INDIVIDUAL && <label htmlFor="sponsorName" className="form-label w-100"><span className='text-danger'>*</span> Company Name</label>}
                                </div>
                                <div className="col-8">
                                    {SponserName}
                                    {errors.sponsorName && <span className="text-danger fst-italic fs-6">{errors.sponsorName.message}</span>}
                                    {/* {errors.sponsorName?.type === "maxLengthCheck" && <span className="text-danger fst-italic fs-6">Must be shorter than 80 characters</span>} */}
                                </div>
                            </div>
                        </div>
                        <div className="row pb-3 justify-content-center">
                            <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                                <div className="col-4 text-start">
                                    <label htmlFor="mobile" className="form-label w-100"><span className='text-danger'>*</span> Mobile</label>
                                </div>
                                <div className="col-8">
                                    {Mobile}
                                    {errors.mobile && <p className="text-danger fst-italic fs-6">{errors.mobile.message}</p>}
                                </div>
                            </div>
                        </div>
                        <div className="row pb-3 justify-content-center">
                            <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                                <div className="col-4 text-start">
                                    <label htmlFor="email" className="form-label w-100"><span className='text-danger'>*</span> Email</label>
                                </div>
                                <div className="col-8">
                                    {Email}
                                    {errors.email && <p className="text-danger fst-italic fs-6">{errors.email.message}</p>}
                                </div>
                            </div>
                        </div>

                        {newEnq.insuredType == appConstants.INSURED_TYPE_INDIVIDUAL && newEnq.visaType != appConstants.VISA_TYPE_SELF_DEP &&
                            <div className="row pb-3 justify-content-center">
                                <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                                    <div className="col-4 text-start d-flex align-items-center">
                                        <label htmlFor="isSponsorMember" className="form-label w-100"><span className='text-danger'>*</span> Add Sponsor To Policy?</label>
                                    </div>
                                    <div className="col-8">

                                        <input
                                            name='isSponsorMember'
                                            id='isSponsorMember'
                                            type="checkbox"
                                            checked={newEnq?.isSponsorMember}
                                            disabled={newEnq?.isRefertoUW || newEnq?.isPolicyIssued}
                                            {...register("isSponsorMember", { onChange: (e) => handleBasicInfoQuoteCheckBoxChange(e) })}

                                        />
                                        <label className="form-check-label ms-1 mx-2" htmlFor="isSponsorMember" >Yes</label>

                                        <input
                                            name='isSponsorMemberN'
                                            id='isSponsorMemberN'
                                            type="checkbox"
                                            checked={newEnq?.isSponsorMemberN}
                                            disabled={newEnq?.isRefertoUW || newEnq?.isPolicyIssued}
                                            {...register("isSponsorMemberN", { onChange: (e) => handleBasicInfoQuoteCheckBoxChangeNo(e) })}

                                        />
                                        <label className="form-check-label ms-1" htmlFor="isSponsorMemberN"  >No</label>
                                    </div>
                                </div>

                            </div>
                        }
                        {newEnq.insuredType != appConstants.INSURED_TYPE_INDIVIDUAL &&
                            <>
                                <div className="row pb-3 justify-content-center">
                                    <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                                        <div className="col-4 text-start">
                                            <label htmlFor="crNo" className="form-label w-100"><span className='text-danger'>*</span> Cr No</label>
                                        </div>
                                        <div className="col-8">
                                            {CrNo}
                                            {errors.crNo && <p className="text-danger fst-italic fs-6">{errors.crNo.message}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row pb-3 justify-content-center">
                                    <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                                        <div className="col-4 text-start">
                                            <label htmlFor="tradeLicNo" className="form-label w-100"><span className='text-danger'>*</span> Trade License No</label>
                                        </div>
                                        <div className="col-8">
                                            {TradeLicNo}
                                            {errors.tradeLicNo && <p className="text-danger fst-italic fs-6">{errors.tradeLicNo.message}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row pb-3 justify-content-center">
                                    <div className="col-lg-6 col-md-8 col-sm-12 d-flex">
                                        <div className="col-4 text-start">
                                            <label htmlFor="tradeLicExp" className="form-label w-100"><span className='text-danger'>*</span> Trade License Expiry Date</label>
                                        </div>
                                        <div className="col-8">
                                            {TradeLicExp}
                                            {errors.tradeLicExp && <p className="text-danger fst-italic fs-6">{errors.tradeLicExp.message}</p>}
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                </div>
                <Box sx={{ marginTop: 2, display: 'flex', justifyContent: 'flex-end' }}>

                    <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        // onClick={handleNext}
                        endIcon={
                            <ArrowForwardIcon />
                        }
                    >
                        Next
                    </Button>
                </Box>
            </form>}
            {modalState?.showSearch &&
                <SearchQuote />

            }



        </>

    )

    function getTermsandConditions() {

        const downloadPrivacyNotice = () => {
            window.open("https://static1.alsagrins.ae/general/PrivacyNotice.pdf");
        }
        return (
            <div>


                <p>  By continuing, you agree to our <a href="#" onClick={() => downloadPrivacyNotice()}>Privacy Notice</a>. Please review it before proceeding. </p>





            </div>

        )
    }
}